import useValue from '../use-value'

export type LOCAL_TYPE = 'ko-KR' | 'zh-CN' | 'en'
const useLocal: () => [LOCAL_TYPE, any] = () => {
  const [local, $local] = useValue(process.env.REACT_APP_LANGUAGE || 'en')
  return [local, $local]
}

export default useLocal
